// ToastComponents should not have any spacing styling (padding, margins) and let <Toast/> dictate that to keep the styling consistent across all toasts
export const ToastComponents = {};
